import React, { useState } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css'; // Ensure the correct path to your CSS
   import { NavLink, useNavigate } from "react-router-dom";  // Import useNavigate
 import {removeToken} from '../Login/Authutils' //removes token from localstorage
import logo from "./logo.png";
  import axios from 'axios';

function HitkariSidebar() {
  const navigate = useNavigate();  // Hook to navigate
    const baseUrl = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 
  const [activeLink, setActiveLink] = useState(null);
  
  const handleLinkClick = (link) => {
      setActiveLink(link);
    };
    
    const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
const handleLogout = async () => {
            try {
              // 1. Call the backend /logout endpoint
              await axios.post(`${baseUrl}/logout`, {}, { withCredentials: true });  // Adjust URL if needed.  Include `withCredentials: true`
        
              // 2. Remove token from localStorage
              removeToken();
        
              // 3. Redirect to login page
              navigate('/login');
            } catch (error) {
              console.error("Logout failed:", error);
              // Handle error (e.g., show an error message to the user)
            }
          };
        
  return (
    <div>
      <div className="hitkari-header">
        <div className="hitkari-header-left">
          <a href="/dash" className="hitkari-logo">
            <img src={logo} alt="Hitkari Logo" />
          </a>
          <button className="hitkari-sidebar-toggle" onClick={toggleSidebar}>
            <i className="fa fa-bars"></i>
          </button>
        </div>
        <button onClick={handleLogout} className="btn btn-primary">
            Logout
          </button>
      </div>

      <div className={`hitkari-sidebar ${isOpen ? 'hitkari-sidebar-open' : ''}`} id="hitkari-sidebar">
        <div className="hitkari-sidebar-inner slimscroll">
          <div id="hitkari-sidebar-menu" className="hitkari-sidebar-menu">
            <ul>
              <li className="hitkari-menu-title">
              
              </li>
              <li>
                <a
                  href="/dash"
                  className={`hitkari-menu-link ${activeLink === 'dashboard' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('dashboard')}
                >
                  <i className="fe fe-home"></i> <span>Dashboard</span>
                </a>
              </li>
              <li>
                                    <a
                                        href="/adddoctorprofile"
                                        className={`hitkari-menu-link ${activeLink === 'adddoctorprofile' ? 'hitkari-active-admin' : ''}`}
                                        onClick={() => handleLinkClick('adddoctorprofile')}
                                    >
                                        <i className="fe fe-activity"></i> <span>Add Doctor Profile</span>
                                    </a>
                                </li>
              <li>
                <a
                  href="/appoint"
                  className={`hitkari-menu-link ${activeLink === 'appointments' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('appointments')}
                >
                  <i className="fe fe-layout"></i> <span>Appointments</span>
                </a>
              </li>
              {/* <li>
                <a
                  href="/tester"
                  className={`hitkari-menu-link ${activeLink === 'specialities' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('specialities')}
                >
                  <i className="fe fe-users"></i> <span>Specialities</span>
                </a>
              </li> */}
              <li>
                <a
                  href="/doctor"
                  className={`hitkari-menu-link ${activeLink === 'doctors' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('doctors')}
                >
                  <i className="fe fe-user-plus"></i> <span>Doctors</span>
                </a>
              </li>
{/* <li>
                <a
                  href="/patient"
                  className={`hitkari-menu-link ${activeLink === 'Patients' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Patients')}
                >
                  <i className="fe fe-activity"></i> <span>Add Patients</span>
                </a>
              </li> */}
           
              <li>
                <a
                  href="/addblogs"
                  className={`hitkari-menu-link ${activeLink === 'Blogs' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Blogs')}
                >
                  <i className="fe fe-activity"></i> <span>Blogs</span>
                </a>
              </li>
              <li>
                <a
                  href="/addgallery"
                  className={`hitkari-menu-link ${activeLink === 'Gallery' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Gallery')}
                >
                  <i className="fe fe-activity"></i> <span>Gallery</span>
                </a>
              </li>
              <li>
                <a
                  href="/addvideos"
                  className={`hitkari-menu-link ${activeLink === 'Videos' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Videos')}
                >
                  <i className="fe fe-activity"></i> <span>Videos</span>
                </a>
              </li>
              <li>
                <a
                  href="/addcarousel"
                  className={`hitkari-menu-link ${activeLink === 'Carousel' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Carousel')}
                >
                  <i className="fe fe-activity"></i> <span>Slider</span>
                </a>
              </li>
               <li>
                <a
                  href="/feedback"
                  className={`hitkari-menu-link ${activeLink === 'Feedbacks' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Feedbacks')}
                >
                  <i className="fe fe-user-plus"></i> <span>Inquiry</span>
                </a>
              </li>
                <li>
                <a
                  href="/viewjob"
                  className={`hitkari-menu-link ${activeLink === 'viewjob' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Changepass')}
                >
                  <i className="fe fe-activity"></i> <span>View Job APP.</span>
                </a>
              </li>
               <li>
                <a
                  href="/addjobname"
                  className={`hitkari-menu-link ${activeLink === 'addjobnames' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Changepass')}
                >
                  <i className="fe fe-activity"></i> <span>ADD Job Name</span>
                </a>
              </li>
               <li>
                <a
                  href="/changepassword"
                  className={`hitkari-menu-link ${activeLink === 'Changepass' ? 'hitkari-active-admin' : ''}`}
                  onClick={() => handleLinkClick('Changepass')}
                >
                  <i className="fe fe-activity"></i> <span>Change Password</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default HitkariSidebar;